module.exports = __webpack_public_path__ + "static/media/align-slash.1db41ce9.svg";